import React from 'react';

import LegalDocumentPage from './LegalDocumentPage';
import operatingRulesContent from './content/operatingRules';

function OperatingRules() {
  return <LegalDocumentPage document={operatingRulesContent} />;
}

export default OperatingRules;
